<template>
  <img src="~/assets/icon/icon-mir.svg" />
</template>
